<div class="space-y-6">
  <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
    <ui-button-group gap="sm" size="sm" [fullWidthMobile]="true">
      <ui-button
        [variant]="selectedFilter === 'expired' ? 'primary' : 'ghost'"
        size="sm"
        (clicked)="setFilter('expired')"
        [disabled]="loading"
        title="Show expired products">
        Expired
      </ui-button>

      <ui-button
        [variant]="selectedFilter === '7' ? 'primary' : 'ghost'"
        size="sm"
        (clicked)="setFilter('7')"
        [disabled]="loading"
        title="Show products expiring within 7 days">
        Next 7 days
      </ui-button>

      <ui-button
        [variant]="selectedFilter === '14' ? 'primary' : 'ghost'"
        size="sm"
        (clicked)="setFilter('14')"
        [disabled]="loading"
        title="Show products expiring within 14 days">
        Next 14 days
      </ui-button>
    </ui-button-group>

  </div>

  @if (loading) {
    <div class="flex justify-center items-center min-h-[20vh]">
      <span class="loading loading-spinner loading-md"></span>
      <strong class="ml-3">Loading...</strong>
    </div>
  } @else {
    @if (products.length === 0) {
      <div class="text-center py-10 text-base-content/60">
        No expiring products found for the selected range.
      </div>
    } @else {
      <ui-list variant="bordered">
        @for (p of products; track trackById($index, p)) {
          <ui-list-item [clickable]="true" [routerLink]="['/products/', p.id]">
            <div class="flex items-center gap-3 w-full">
              <div class="product-thumb">
                <img
                  [src]="p.primary_thumb_image?.url || p.image_thumb_url || 'https://placehold.co/48x48/EEE/31343C?font=noto-sans&text=' + p.name"
                  alt="{{ p.name || 'Product image' }}"/>
              </div>

              <div class="min-w-0 flex-1">
                <div class="font-medium text-base-content truncate">
                  {{ p.name || 'Not Set' }}
                </div>
                <div class="text-sm text-base-content/60">
                  Expiration: {{ formatDate(p.stock?.next_expiration) || '—' }}
                </div>
              </div>

              <div class="text-sm text-base-content/70 text-right whitespace-nowrap shrink-0">
                {{ formatDate(p.stock?.next_expiration) || '—' }}
              </div>
            </div>
          </ui-list-item>
        }
      </ui-list>
    }
  }
</div>
